import { render, staticRenderFns } from "./DentalPolyAssestment.vue?vue&type=template&id=9a0a2dbc&scoped=true"
import script from "./DentalPolyAssestment.vue?vue&type=script&lang=js"
export * from "./DentalPolyAssestment.vue?vue&type=script&lang=js"
import style0 from "./DentalPolyAssestment.vue?vue&type=style&index=0&id=9a0a2dbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a0a2dbc",
  null
  
)

export default component.exports